import React, { useCallback, useEffect, useState } from 'react';
import LogoEditor from './components/LogoEditor/LogoEditor';
import Logos from './components/Logos/Logos';
import { useHistory, useLocation } from 'react-router-dom';

const INITIAL_LOGO = { id: null, isEdit: false };

const LogoSettings = ({ companyId }) => {
  const [logoToEdit, setLogoToEdit] = useState(INITIAL_LOGO);
  const history = useHistory();
  const { state, search } = useLocation();

  const handleOpenEditor = useCallback(
    id => {
      history.push({ pathname: `/eg/company-settings`, state: { ...state, logoId: id }, search });
    },
    [state, search]
  );

  const handleCloseEditor = useCallback(() => {
    history.goBack();
  }, []);

  useEffect(() => {
    if (state.option && state?.logoId) {
      setLogoToEdit({ id: state.logoId, isEdit: true });
    } else {
      setLogoToEdit(INITIAL_LOGO);
    }
  }, [state]);

  return (
    <>
      {logoToEdit.isEdit ? (
        <LogoEditor logoId={logoToEdit.id} onClose={handleCloseEditor} companyId={companyId} />
      ) : (
        <Logos handleOpenEditor={handleOpenEditor} companyId={companyId} />
      )}
    </>
  );
};

export default LogoSettings;
